import { NavLink } from "react-router-dom";
import { useT } from "../i18n";

/** Thanh tab chung cho nhóm trang Ôn tập. */
export function ReviewTabs() {
  const t = useT();
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);
  return (
    <nav className="tabs" aria-label={t("Ôn tập", "Review")}>
      <NavLink to="/review" className={cls}>{t("Ôn câu hỏi", "Question review")}</NavLink>
      <NavLink to="/flashcards" className={cls}>Flashcards</NavLink>
    </nav>
  );
}
